<template>
  <v-select
    outlined
    :items="rubros"
    item-text="descripcion"
    item-value="id"
    :label="title"
    return-object
    v-model="selectedRubro"
    @change="handleRubroChange"
  ></v-select>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: 'RubroVentaListSelect',
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: "Rubro venta",
    },
  },

  data() {
    return {
      selectedRubro: this.value,
      rubros: [],
    };
  },
  computed: {
    ...mapState("contabilidad", ["rubrosVenta"]),
  },
  watch: {
    rubrosVenta: {
      handler() {
        this.rubros = this.rubrosVenta;
      },
      immediate: true,
    },
   
  },
  methods: {
    ...mapActions("contabilidad", ["fetch_rubro_ventas"]),

    handleRubroChange() {
      this.$emit("process-select", this.selectedRubro);
    },
  },
  created() {
    var sucursal_uuid = this.$route.params.uuid_sucursal
    this.fetch_rubro_ventas(sucursal_uuid);
  },
};
</script>
